import { FREE_MAIL_DOMAINS, RELEVANT_COUNTRIES } from '~/constants';

const trackingRelevantBusiness = (trackingData) =>
	trackingData?.isTrial ||
	(['business'].includes(trackingData?.areaOfUse) &&
		RELEVANT_COUNTRIES.includes(trackingData?.countryCode) &&
		!FREE_MAIL_DOMAINS.includes(trackingData?.email?.split('@')[1]));

export default trackingRelevantBusiness;
